export class AdvisorProFreeWillsLimit {
  static MONTHLY_PLAN_LIMIT = 1;
  static ANNUAL_PLAN_LIMIT = 15;
}
